document.addEventListener('DOMContentLoaded', function () {
  const grid = document.querySelector('#product-grid');
  const pagination = document.querySelector('.pagination-wrapper');

  if (!grid || !pagination) return;

  const nextLink = pagination.querySelector('a[aria-label*="Next"], a[href*="page="]');
  if (!nextLink) return;

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'button button--primary load-more-products-button';
  button.textContent = 'Ver más piezas';

  const wrapper = document.createElement('div');
  wrapper.className = 'load-more-products-wrapper';
  wrapper.appendChild(button);

  pagination.insertAdjacentElement('afterend', wrapper);
  pagination.style.display = 'none';

  let nextUrl = nextLink.href;
  let loading = false;

  button.addEventListener('click', function () {
    if (loading || !nextUrl) return;

    loading = true;
    button.textContent = 'Cargando...';
    button.disabled = true;

    fetch(nextUrl)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newItems = doc.querySelectorAll('#product-grid .grid__item');
        const newPagination = doc.querySelector('.pagination-wrapper');
        const newNextLink = newPagination
          ? newPagination.querySelector('a[aria-label*="Next"], a[href*="page="]')
          : null;

        newItems.forEach(item => {
          grid.appendChild(item);
        });

        if (newNextLink) {
          nextUrl = newNextLink.href;
          button.textContent = 'Ver más piezas';
          button.disabled = false;
          loading = false;
        } else {
          nextUrl = null;
          wrapper.remove();
        }
      })
      .catch(() => {
        button.textContent = 'Ha fallado, inténtalo otra vez';
        button.disabled = false;
        loading = false;
      });
  });
});